<template>
  <b-list-group-item>
    <div>
      <div class="text-primary font-weight-bold">
        {{ labelText }}
      </div>
      <b-badge
        v-if="isBadge"
        :variant="badgeVariant"
      >
        {{ valueText? valueText : '-' }}
      </b-badge>
      <div v-else-if="isDate">
        {{ valueText? moment(valueText).format('DD.MM.YYYY') : '-' }}
      </div>
      <div v-else>
        {{ valueText? valueText : '-' }}
      </div>
    </div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem, BBadge } from 'bootstrap-vue'
import moment from 'moment'

export default {
  name: 'ListItem',
  components: {
    BListGroupItem,
    BBadge,
  },
  props: {
    labelText: {
      type: String,
      required: true,
    },
    valueText: {
      type: String,
      required: true,
    },
    isBadge: {
      type: Boolean,
      default: false,
    },
    badgeVariant: {
      type: String,
      default: 'light-info',
    },
    isDate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    moment() {
      return moment
    },
  },
}
</script>
